import { hideLoading, showLoading } from 'components/Loading/LoadingSlice';
import Config from 'configuration';
import moment from 'moment';
import { GinColumns } from 'pages/Admin/Component/Table/TableColumnsConfig';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Utils from 'utils';
import useTableProperties from '../Component/Table/useTableProperties';
import propsProvider from './GinsengPropsProvider';
import {
    deleteGinsengAdmin,
    deleteGinsengFile,
    getListGinsengAdmin,
    insertGinsengAdmin,
    updateGinsengAdmin,
    uploadGinsengFile,
} from './GinsengSlice';
import GinsengMainView from './template/GinsengMainView';

function GinsengContainer(props) {
    const { dispatch, ginsengAdminList } = props;
    const [keyword, setKeyword] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const [data, setData] = useState(ginsengAdminList);
    const [openDialog, setOpenDialog] = useState(false);
    const [ginsengData, setGinsengData] = useState({});
    const [updateData, setUpdateData] = useState(false);
    const [filesImage, setFilesImage] = useState([]);
    const [filesCertificate, setFilesCertificate] = useState([]);
    const [imageRemove, setImageRemove] = useState([]);

    const [isAdd, setIsAdd] = useState(true);
    const intl = useIntl();
    const columns = GinColumns(intl);

    const payload = {
        currentPage: currentPage,
        pageSize: pageSize,
        sortField: 'created_at',
        sortOrder: 'desc',
        filters: '(name|code)@=' + keyword,
    };

    const tableData = useTableProperties(data);

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize, keyword]);

    useEffect(() => {
        dispatch(showLoading());
        const delayDebounceFn = setTimeout(() => {
            dispatch(getListGinsengAdmin(payload)).then((result) => {
                setData(Utils.getValues(result, 'payload.responseData', []));
                dispatch(hideLoading());
            });
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [pageSize, keyword, currentPage, dispatch, updateData]);

    const setStateHandle = (isAdd = false, dataGinseng = {}) => {
        setFilesImage([]);
        setFilesCertificate(null);
        setIsAdd(isAdd);
        setGinsengData(dataGinseng);
        setOpenDialog(true);
    };

    const handleAddClick = (e) => {
        setStateHandle(true, {});
    };

    const handleEditClick = (e) => {
        setStateHandle(false, e);
        setImageRemove([]);
        e.images.forEach((value) => {
            setFilesImage((prev) => [...prev, value]);
        });
    };

    const handleImage = (item) => {
        if (item instanceof File) {
            return URL.createObjectURL(item);
        } else {
            return Config.domain + item.file_path.substring(1);
        }
    };

    const handleDeleteClick = async (e) => {
        const result = await Utils.handleConfirmDelete(intl);
        if (result.isConfirmed) {
            dispatch(showLoading());
            await dispatch(deleteGinsengAdmin(e.data.id)).then((result) => {
                const status = Utils.getValues(result, 'payload.status', null);
                if (status === Config.SUCCESS) {
                    setUpdateData(!updateData);
                    Utils.handlePopup(intl.messages.deleteSuccess, 'success');
                } else {
                    Utils.handlePopup(intl.messages.deleteFail, 'error');
                }
            });
            dispatch(hideLoading());
        }
    };

    const initialValues = {
        name: '',
        code: '',
        created_at: Utils.formatDateYDM(moment()),
        source: '',
        use_of_ginseng: '',
        other_information: '',
        ginseng_certificates: intl.messages.chooseFile,
    };

    const handleValidation = (data, isAdd) => {
        if (!data.code.trim()) {
            Utils.handlePopup(intl.messages.requiredCode, 'error');
            return true;
        }
        if (!data.name.trim()) {
            Utils.handlePopup(intl.messages.requiredName, 'error');
            return true;
        }
        if (!data.created_at) {
            Utils.handlePopup(intl.messages.requiredDate, 'error');
            return true;
        }
        if (!data.source.trim()) {
            Utils.handlePopup(intl.messages.requiredSource, 'error');
            return true;
        }
        if (!data.use_of_ginseng.trim()) {
            Utils.handlePopup(intl.messages.requiredUseOf, 'error');
            return true;
        }
        if (isAdd) {
            if (!filesCertificate) {
                Utils.handlePopup(intl.messages.requiredFile, 'error');
                return true;
            }
        }
        if (filesImage.length < 1) {
            Utils.handlePopup(intl.messages.requiredAvatar, 'error');
            return true;
        }
        return false;
    };

    const handleSubmit = async (e, { resetForm }) => {
        if (handleValidation(e, isAdd)) return;

        dispatch(showLoading());

        let status = Config.FAIL;
        const formData = new FormData();

        const ginseng = {
            name: e.name,
            code: e.code,
            created_at: e.created_at,
            source: e.source,
            use_of_ginseng: e.use_of_ginseng,
            other_information: e.other_information,
        };

        const payloadAvt = {
            type: 'ginseng',
        };

        const uploadPromises = [];

        const processFile = async (file) => {
            const formDataImage = new FormData();
            formDataImage.append('file', file);
            formDataImage.append('meta', JSON.stringify(payloadAvt));
            const result = await dispatch(uploadGinsengFile(formDataImage));
            const responseData = Utils.getValues(result, 'payload.responseData', {});
            return { id: responseData.id, file_path: responseData.file_path };
        };
        if (isAdd) {
            for (const file of filesImage) {
                uploadPromises.push(Utils.processFile(dispatch, file));
            }
            try {
                const imageList = await Promise.all(uploadPromises);
                ginseng['images'] = imageList;
                formData.append('file', filesCertificate);
                formData.append('ginseng', JSON.stringify(ginseng));
                const result = await dispatch(insertGinsengAdmin(formData));
                status = Utils.getValues(result, 'payload.status', Config.FAIL);
            } catch (error) {}
        } else {
            const newFiles = filesImage.filter((item) => item instanceof File);
            const oldFiles = filesImage.filter(
                (item) => item instanceof Object && !(item instanceof File),
            );

            if (imageRemove.length > 0) {
                const deletePromises = imageRemove.map((value) =>
                    dispatch(deleteGinsengFile(value.id)),
                );
                await Promise.all(deletePromises);
            }
            for (const file of newFiles) {
                uploadPromises.push(processFile(file));
            }
            try {
                const newImageList = await Promise.all(uploadPromises);
                ginseng['images'] = [...oldFiles, ...newImageList];
                formData.append('file', filesCertificate);
                formData.append('ginseng', JSON.stringify(ginseng));
                const updateGinseng = {
                    id: e.id,
                    formData: formData,
                };
                const result = await dispatch(updateGinsengAdmin(updateGinseng));
                status = Utils.getValues(result, 'payload.status', Config.FAIL);
            } catch (error) {
                Utils.handlePopup(
                    isAdd ? intl.messages.addFail : intl.messages.updateFail,
                    'error',
                );
            }
        }
        if (status === Config.SUCCESS) {
            setUpdateData(!updateData);
            Utils.handlePopup(
                isAdd ? intl.messages.addSuccess : intl.messages.updateSuccess,
                'success',
            );
        } else {
            Utils.handlePopup(isAdd ? intl.messages.addFail : intl.messages.updateFail, 'error');
        }
        dispatch(hideLoading());
        resetForm({ values: '' });
        setOpenDialog(false);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleOnchangeImage = (e) => {
        if (e.target.files[0]) {
            setFilesImage((prev) => [...prev, e.target.files[0]]);
        }
    };
    const handleRemoveImage = (e) => {
        setImageRemove((prev) => [...prev, e]);
        const newFiles = filesImage.filter((item) => item !== e);
        setFilesImage(newFiles);
    };

    const onChangeFileCertificate = (e) => {
        const text = document.getElementById('file-text');
        if (e.target.files.length > 0) {
            text.innerHTML = e.target.files[0].name;
            text.style.color = '#0288d1';
            setFilesCertificate(e.target.files[0]);
        } else {
            text.innerHTML = intl.messages.chooseFile;
            text.style.color = '#9ea4aa';
        }
    };

    const ginsengContainerProps = {
        ...props,
        intl,
        columns,
        keyword,
        pageSize,
        setPageSize,
        currentPage,
        setCurrentPage,
        setKeyword,
        handleEditClick,
        handleDeleteClick,
        openDialog,
        handleCloseDialog,
        isAdd,
        handleSubmit,
        initialValues,
        ginsengData,
        filesImage,
        handleAddClick,
        handleRemoveImage,
        handleOnchangeImage,
        onChangeFileCertificate,
        tableData,
        ginsengAdminList,
        handleImage,
    };
    return <GinsengMainView {...propsProvider(ginsengContainerProps)} />;
}

export default GinsengContainer;
